export default 'https://storage.googleapis.com/hom-frontend-assets/next/assets/icons/brain-heart.svg'
